export enum LearnModuleStatus {
    init = 'not-started',
    inProgress = 'in-progress',
    completed = 'completed',
}
